import { useShortestPathLegacy } from "./legacy"
import { FeaturePropType, UseShortestPathOptions } from "./shared"
import { useShortestPathVenueSDK } from "./venue-sdk"

const strategyHook = {
  legacy: useShortestPathLegacy,
  "venue-sdk": useShortestPathVenueSDK,
} as const
export interface IUseShortestPathStrategyOptions
  extends UseShortestPathOptions {
  strategy?: keyof typeof strategyHook
}

export const useShortestPathStrategy = (
  imdfData: FeaturePropType,
  { strategy = "legacy", ...options }: IUseShortestPathStrategyOptions
) => {
  const implementHook = strategyHook[strategy] ?? strategyHook.legacy

  return implementHook(imdfData, options)
}
